document.addEventListener('DOMContentLoaded', function () {
    const howItWorksSection = document.querySelector('.how-it-works-section');
    const autoplay = howItWorksSection.getAttribute('data-autoplay');
    const autoplayDelay = howItWorksSection.getAttribute('data-autoplay-delay');
    const loop = howItWorksSection.getAttribute('data-loop');

    if (window.innerWidth <= 750) {
        new Swiper('.how-it-works-section .mySwiper', {
            pagination: {
                el: '.how-it-works-section .swiper-pagination',
            },
            loop: loop,
            autoplay: {
                enabled: autoplay,
                delay: autoplayDelay,
                disableOnInteraction: false,
            },

        });
    }
});
